import classNames from 'classnames'

import { ListItem } from '../ListItem'
import { LoaderListItemContent } from '../LoaderListItemContent'

import * as styles from './LoaderListItem.module.css'

function LoaderListItem({ className, ...restProps }) {
  const listItemClass = classNames(styles.LoaderListItem, className)

  return (
    <ListItem
      {...restProps}
      Content={LoaderListItemContent}
      className={listItemClass}
    />
  )
}

export default LoaderListItem
